const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRule5GptLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.732,
    height: 92.732,
    viewBox: "0 0 24.535 24.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-95.943 -13.791)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1976d2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.311602,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    width: 24.535,
    height: 24.535,
    x: 95.943,
    y: 13.791,
    ry: 4.223
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "23.2816px",
      lineHeight: 1.15,
      fontFamily: "Avenir",
      InkscapeFontSpecification: "Avenir",
      letterSpacing: 0,
      opacity: 0.947712,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.351371,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M101.485 25.949s-.088-.998-.117-2.02h-1.75c.155 4.493.125 8.989.145 13.483h1.752v-7.354c0-2.2 1.546-4.727 4.377-4.727.233 0 .39 0 .68.068l.225-1.674c-3.865-.67-5.312 2.224-5.312 2.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947712,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.775816,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M110.014 15.208s-.368 4.457-.512 6.347l-.013.125h1.094l.035-.037a2.852 2.852 0 0 1 1.136-.75 4.037 4.037 0 0 1 1.357-.24c.464 0 .872.075 1.228.217.359.143.656.34.897.596v.001c.25.257.438.556.567.907.128.35.193.736.193 1.155 0 .405-.061.802-.185 1.192-.115.381-.296.725-.547 1.032a2.796 2.796 0 0 1-.955.728c-.375.185-.826.278-1.355.278-.318 0-.62-.039-.906-.118a2.761 2.761 0 0 1-.764-.371 2.202 2.202 0 0 1-.573-.647 2.768 2.768 0 0 1-.332-.942l-.017-.099h-1.224l.014.133c.068.51.21.97.425 1.37l.004.003c.222.39.499.722.83.993h.004c.338.262.724.461 1.152.6.43.137.89.207 1.385.207.69 0 1.297-.11 1.82-.333h.005c.496-.213.94-.531 1.3-.934a3.8 3.8 0 0 0 .783-1.403v-.003a5.483 5.483 0 0 0 .263-1.72c0-.55-.096-1.067-.287-1.55a3.84 3.84 0 0 0-.795-1.252 3.561 3.561 0 0 0-1.198-.854 3.616 3.616 0 0 0-1.499-.312c-.228 0-.464.012-.713.036-.251.023-.5.064-.743.125-.249.054-.49.14-.717.253-.142.07-.26.175-.386.269l.377-3.877h5.37V15.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule5GptLogo);
export default __webpack_public_path__ + "static/media/rule5gpt_logo.698d8ec1aad228627942c1d9695ac339.svg";
export { ForwardRef as ReactComponent };